import Vue from 'vue'
import VueRouter from 'vue-router'

const Index = () => import("../views/index/Index");
const MerchantsInsert = () => import("../views/merchants/MerchantsInsert");
const UserList = () =>  import("../views/user/UserList");
const User = () =>  import("../views/user/User");
const UserData = () =>  import("../views/user/UserData");
const Merchants = () =>  import("../views/merchants/Merchants");
const MerchantsList = () =>  import("../views/merchants/MerchantsList");
const MerchantsData = () =>  import("../views/merchants/MerchantsData");
const SkuInfo = () =>  import("../views/earth_plan/SkuInfo");
const SkuInfoData = () =>  import("../views/earth_plan/SkuInfoData");
const SkuInfoInsert = () =>  import("../views/earth_plan/SkuInfoInsert");
const SkuInfoList = () =>  import("../views/earth_plan/SkuInfosList");
const Video = () =>  import("../views/video/Video");
const VideoData = () =>  import("../views/video/VideoData");
const VideoInsert = () =>  import("../views/video/VideoInsert");
const VideoList = () =>  import("../views/video/VideoList");
const DailyPush = () => import("../views/dailyPush/DailyPush");
const DailyPushList = () => import("../views/dailyPush/DailyPushList");
const Swiper = () => import("../views/swiper/Swiper");
const SwiperList = () => import("../views/swiper/SwiperList");
const SwiperInsert = () => import("../views/swiper/SwiperInsert");
const Order = () => import("../views/order/Order")
const OrderList = () => import("../views/order/OrderList")
const OrderData = () => import("../views/order/OrderData")
const Coupons = () => import("../views/coupons/Coupons")
const CouponsList = () => import("../views/coupons/CouponsList")
const CouponsData = () => import("../views/coupons/CouponsData")
const CouponsInsert = () => import("../views/coupons/CouponsInsert")
const Message = () => import("../views/message/Message")
const MessageList = () => import("../views/message/MessageList")
const MessageInsert = () => import("../views/message/MessageInsert")
const Label = () => import("../views/label/Label")
const LabelList = () => import("../views/label/LabelList")
const LabelInsert = () => import("../views/label/LabelInsert")
const Admin = () => import("../views/admin/Admin")
const AdminList = () => import("../views/admin/AdminList")
const AdminInsert = () => import("../views/admin/AdminInsert")
const AdminData = () => import("../views/admin/AdminData")
const Role = () => import("../views/role/Role")
const RoleData = () => import("../views/role/RoleData")
const Login = () => import("../views/login/Login")
const Version = () => import("../views/version/Version")
const VersionList = () => import("../views/version/VersionList")
const VersionInsert = () => import("../views/version/VersionInsert")
const Terms = () => import("../views/terms/Terms")
const TermsList = () => import("../views/terms/TermsList")
const TermsInsert = () => import("../views/terms/TermsInsert")
const UserCoupons = () => import("../views/user_coupons/UserCoupons")
const UserCouponsData = () => import("../views/user_coupons/UserCouponsData")
const UserCouponsList = () => import("../views/user_coupons/UserCouponsList")
const ShareList = () => import("../views/share/ShareList")
const Share = () => import("../views/share/Share")
const MarketingMerchants = () =>  import("../views/marketingMerchants/MarketingMerchants");
const MarketingMerchantsList = () =>  import("../views/marketingMerchants/MarketingMerchantsList");
const MarketingMerchantsData = () =>  import("../views/marketingMerchants/MarketingMerchantsData");
const MarketingMerchantsInsert = () => import("../views/marketingMerchants/MarketingMerchantsInsert");
const Activity = () =>  import("../views/Activity/Activity");
const ActivityList = () =>  import("../views/Activity/ActivityList");
const ActivityInsert = () => import("../views/Activity/ActivityInsert");
const Guess = () =>  import("../views/Guess/Guess");
const GuessList = () =>  import("../views/Guess/GuessList");
const GuideImg = () =>  import("../views/guideImg/GuideImg");
const GuideImgList = () =>  import("../views/guideImg/GuideImgList");
const GuideImgInsert = () => import("../views/guideImg/GuideImgInsert");

const CoveShed = () =>  import("../views/coveShed/CoveShed");
const CoveShedData = () =>  import("../views/coveShed/CoveShedData");
const CoveShedInsert = () =>  import("../views/coveShed/CoveShedInsert");
const CoveShedList = () =>  import("../views/coveShed/CoveShedList");
const CoveShedAddress = () => import("../views/coveShedAddress/coveShedAddress")
const CoveShedAddressList = () => import("../views/coveShedAddress/coveShedAddressList")
const CoveShedAddressInsert = () => import("../views/coveShedAddress/coveShedAddressInsert")

const Collector = () =>  import("../views/collector/Collector");
const CollectorList = () =>  import("../views/collector/CollectorList");
const CollectorInsert = () =>  import("../views/collector/CollectorInsert");
const CollectorDetail = () =>  import("../views/collector/CollectorDetail");
const CollectorOrderList = () =>  import("../views/collector/CollectorOrderList");
const CollectorOrderInsert = () =>  import("../views/collector/CollectorOrderInsert");
const CollectorOrderDetail = () =>  import("../views/collector/CollectorOrderDetail");

const DistributionConfiguration = () =>  import("../views/distribution/DistributionConfiguration");

const ReflectRecordList = () =>  import("../views/reflectRecord/ReflectRecordList");

const TraceabilityDetails = () => import("../views/external/TraceabilityDetails")




Vue.use(VueRouter)

const routes = [
    {
        path: '/external/TraceabilityDetails/:id',
        name: 'traceabilityDetails',
        component: TraceabilityDetails
    },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/xsalocenter',
    component: Index
  },
  {
    path: '/user',
    component: User,
    children:[
      {
        path: 'list',
        name: 'userList',
        component: UserList
      },
      {
        path: 'data/:id',
        name: 'userData',
        component: UserData
      }
    ]
  },
  {
    path: '/merchants',
    component: Merchants,
    children:[
      {
        path: 'list',
        name: 'merchantsList',
        component: MerchantsList
      },
      {
        path: 'data/:id',
        name: 'merchantsData',
        component: MerchantsData
      },
      {
        path: 'insert/:id',
        name: 'merchantsUpdate',
        component: MerchantsInsert
      },
      {
        path: 'insert',
        name: 'merchantsInsert',
        component: MerchantsInsert
      }
    ]
  },
  {
    path: '/coveShed',
    component: CoveShed,
    children:[
      {
        path: 'list',
        name: 'coveShedList',
        component: CoveShedList
      },
      {
        path: 'data/:id',
        name: 'coveShedData',
        component: CoveShedData
      },
      {
        path: 'insert/:id',
        name: 'coveShedUpdate',
        component: CoveShedInsert
      },
      {
        path: 'insert',
        name: 'CoveShedInsert',
        component: CoveShedInsert
      }
    ]
  },
  {
    path: '/coveShedAddress',
    component: CoveShedAddress,
    children:[
      {
        path: 'list',
        name: 'coveShedAddressList',
        component: CoveShedAddressList,
      },
      {
        path: 'insert/:id',
        name: 'coveShedAddressUpdate',
        component: CoveShedAddressInsert,
      },
      {
        path: 'insert',
        name: 'coveShedAddressInsert',
        component: CoveShedAddressInsert,
      }
    ]
  },
  {
    path: '/pmsSkuInfo',
    component: SkuInfo,
    children:[
      {
        path: 'list',
        name: 'skuInfoList',
        component: SkuInfoList,
      },
      {
        path: 'data/:id',
        name: 'skuInfoData',
        component: SkuInfoData,
      },
      {
        path: 'insert/:id',
        name: 'skuInfoUpdate',
        component: SkuInfoInsert,
      },
      {
        path: 'insert',
        name: 'skuInfoInsert',
        component: SkuInfoInsert,
      },
    ]
  },
  {
    path: '/video',
    component: Video,
    children:[
      {
        path: 'list',
        name: 'videoList',
        component: VideoList,
      },
      {
        path: 'data/:id',
        name: 'videoData',
        component: VideoData,
      },
      {
        path: 'insert/:id',
        name: 'videoUpdate',
        component: VideoInsert,
      },
      {
        path: 'insert',
        name: 'videoInsert',
        component: VideoInsert,
      },
    ]
  },
  {
    path: '/dailyPush',
    component: DailyPush,
    children:[
      {
        path: 'list',
        name: 'dailyPushList',
        component: DailyPushList,
      },
    ]
  },
  {
    path: '/swiper',
    component: Swiper,
    children:[
      {
        path: 'list',
        name: 'swiperList',
        component: SwiperList,
      },
      {
        path: 'insert',
        name: 'SwiperInsert',
        component: SwiperInsert,
      },
      {
        path: 'insert/:id',
        name: 'SwiperUpdate',
        component: SwiperInsert,
      }
    ]
  },
  {
    path: '/marketingMerchants',
    component: MarketingMerchants,
    children:[
      {
        path: 'list',
        name: 'marketingMerchantsList',
        component: MarketingMerchantsList
      },
      {
        path: 'data/:id',
        name: 'marketingMerchantsData',
        component: MarketingMerchantsData
      },
      {
        path: 'insert/:id',
        name: 'marketingMerchantsUpdate',
        component: MarketingMerchantsInsert
      },
      {
        path: 'insert',
        name: 'marketingMerchantsInsert',
        component: MarketingMerchantsInsert
      }
    ]
  },
  {
    path: '/activity',
    component: Activity,
    children:[
      {
        path: 'list',
        name: 'activityList',
        component: ActivityList
      },
      {
        path: 'insert/:id',
        name: 'activityUpdate',
        component: ActivityInsert
      },
      {
        path: 'insert',
        name: 'activityInsert',
        component: ActivityInsert
      }
    ]
  },
  {
    path: '/guess',
    component: Guess,
    children:[
      {
        path: 'list/:id',
        name: 'guessList',
        component: GuessList
      },
    ]
  },
  {
    path: '/order',
    component: Order,
    children:[
      {
        path: 'list',
        name: 'orderList',
        component: OrderList,
      },
      {
        path: 'data/:id',
        name: 'orderData',
        component: OrderData,
      }
    ]
  },
  {
    path: '/coupons',
    component: Coupons,
    children:[
      {
        path: 'list',
        name: 'CouponsList',
        component: CouponsList,
      },
      {
        path: 'data/:id',
        name: 'CouponsData',
        component: CouponsData,
      },
      {
        path: 'insert',
        name: 'CouponsInsert',
        component: CouponsInsert,
      },
      {
        path: 'insert/:id',
        name: 'CouponsUpdate',
        component: CouponsInsert,
      }
    ]
  },
  {
    path: '/userCoupons',
    component: UserCoupons,
    children:[
      {
        path: 'list',
        name: 'UserCouponsList',
        component: UserCouponsList,
      },
      {
        path: 'data/:id',
        name: 'UserCouponsData',
        component: UserCouponsData,
      },
      {
        path: 'list/:couponsId',
        name: 'UserCouponsList2',
        component: UserCouponsList,
      },
    ]
  },
  {
    path: '/share',
    component: Share,
    children:[
      {
        path: 'list',
        name: 'ShareList',
        component: ShareList,
      },
      {
        path: 'list/:shareCode',
        name: 'ShareList2',
        component: ShareList,
      },
    ]
  },
  {
    path: '/version',
    component: Version,
    children:[
      {
        path: 'list',
        name: 'versionList',
        component: VersionList,
      },
      {
        path: 'insert/:id',
        name: 'versionUpdate',
        component: VersionInsert,
      },
      {
        path: 'insert',
        name: 'versionInsert',
        component: VersionInsert,
      }
    ]
  },
  {
    path: '/guideImg',
    component: GuideImg,
    children:[
      {
        path: 'list',
        name: 'guideImgList',
        component: GuideImgList,
      },
      {
        path: 'insert/:id',
        name: 'guideImgUpdate',
        component: GuideImgInsert,
      },
      {
        path: 'insert',
        name: 'guideImgInsert',
        component: GuideImgInsert,
      }
    ]
  },
  {
    path: '/terms',
    component: Terms,
    children:[
      {
        path: 'list',
        name: 'termsList',
        component: TermsList,
      },
      {
        path: 'insert/:id',
        name: 'termsUpdate',
        component: TermsInsert,
      },
      {
        path: 'insert',
        name: 'termsInsert',
        component: TermsInsert,
      }
    ]
  },
  {
    path: '/systemMessage',
    component: Message,
    children:[
      {
        path: 'list',
        name: 'messageList',
        component: MessageList,
      },
      {
        path: 'insert/:id',
        name: 'messageUpdate',
        component: MessageInsert,
      },
      {
        path: 'insert',
        name: 'messageInsert',
        component: MessageInsert,
      }
    ]
  },
  {
    path: '/skuLabel',
    component: Label,
    children:[
      {
        path: 'list',
        name: 'labelList',
        component: LabelList,
      },
      {
        path: 'insert/:id',
        name: 'labelUpdate',
        component: LabelInsert,
      },
      {
        path: 'insert',
        name: 'labelInsert',
        component: LabelInsert,
      }
    ]
  },
  {
    path: '/admin',
    component: Admin,
    children:[
      {
        path: 'list',
        name: 'adminList',
        component: AdminList,
      },
      {
        path: 'data/:id',
        name: 'adminData',
        component: AdminData,
      },
      {
        path: 'insert',
        name: 'adminInsert',
        component: AdminInsert,
      },
      {
        path: 'insert/:id',
        name: 'adminUpdate',
        component: AdminInsert,
      }
    ]
  },
  {
    path: '/collector',
    component: Collector,
    children:[
      {
        path: 'list',
        name: 'collectorList',
        component: CollectorList,
      },
      {
        path: 'insert',
        name: 'collectorInsert',
        component: CollectorInsert,
      },
      {
        path: 'insert/:id',
        name: 'collectorInsert',
        component: CollectorInsert,
      },
      {
        path: 'detail/:id',
        name: 'collectorDetail',
        component: CollectorDetail,
      },
      {
        path: 'orderList',
        name: 'collectorOrderList',
        component: CollectorOrderList,
      },
      {
        path: 'orderInsert',
        name: 'collectorOrderInsert',
        component: CollectorOrderInsert,
      },
      {
        path: 'orderInsert/:id',
        name: 'collectorOrderInsert',
        component: CollectorOrderInsert,
      },
      {
        path: 'orderDetail/:id',
        name: 'collectorOrderDetail',
        component: CollectorOrderDetail,
      }
    ],
  },
  {
    path: '/role',
    component: Role,
    children:[
      {
        path: 'data',
        name: 'roleData',
        component: RoleData,
      }
    ]
  },
  {
    path: '/distribution',
    component: DistributionConfiguration,
    children:[
      {
        path: 'distributionConfiguration',
        name: 'distributionConfiguration',
        component: DistributionConfiguration,
      }
    ]
  },
  {
    path: '/reflectRecord',
    component: ReflectRecordList,
    children:[
      {
        path: 'list',
        name: 'reflectRecordList',
        component: ReflectRecordList,
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
});

export default router
